import { render, staticRenderFns } from "./Landlords.vue?vue&type=template&id=444895e0&"
import script from "./Landlords.vue?vue&type=script&lang=js&"
export * from "./Landlords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Landlords.vue"
export default component.exports